'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _BLOCK_TYPE_MATCH_FUN;

var _lodash = require('lodash');

var _markdownPatternMatcher = require('./markdownPatternMatcher');

var _richTextConstants = require('../../richText/richTextConstants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Utils


// Constants


var BLOCK_TYPE_MATCH_FUNCTIONS_MAP = (_BLOCK_TYPE_MATCH_FUN = {}, _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.HEADING, _markdownPatternMatcher.matchHeading), _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.ORDERED_LIST, _markdownPatternMatcher.matchOrderedList), _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.LIST, _markdownPatternMatcher.matchList), _defineProperty(_BLOCK_TYPE_MATCH_FUN, _richTextConstants.STYLE_COMMANDS.BLOCKQUOTE, _markdownPatternMatcher.matchBlockquote), _BLOCK_TYPE_MATCH_FUN);

exports.default = function (line) {
    return (0, _lodash.reduce)(BLOCK_TYPE_MATCH_FUNCTIONS_MAP, function (acc, fn, blockType) {
        if (acc) return acc;
        return fn(line) ? blockType : null;
    }, null);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/markdownSupport/matchBlockTypeMarkdown.js
// module id = 1739
// module chunks = 0